export interface UserAccess {
  id: number;
  userId: string;
  userName: string;
  deliverableId: number;
  canRead: boolean;
  canWrite: boolean;
  isOwner: boolean;
}

export enum InputTypes {
  text = "text",
  phone = "tel",
  email = "email",
  password = "password",
  number = "number",
  select = "select",
  date = "date",
}
